import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	customizationDesc: {
		id: 'servicedesk-settings-customer-portal-v2.portal-details.customization-desc',
		defaultMessage:
			'Visit your portal to add announcements, group request types, and customize look and feel.',
		description: 'Customization description on customer portal page',
	},
	customizationDescNotAdmin: {
		id: 'servicedesk-settings-customer-portal-v2.portal-details.customization-desc-not-admin',
		defaultMessage: 'Visit your portal to add announcements, and group request types.',
		description: 'Customization description on customer portal page',
	},
	portalUrl: {
		id: 'servicedesk-settings-customer-portal-v2.portal-details.portal-url',
		defaultMessage: 'Portal URL',
		description: 'Heading for the URL to the portal',
	},
	copyUrl: {
		id: 'servicedesk-settings-customer-portal-v2.portal-details.copy-url',
		defaultMessage: 'Copy URL',
		description: 'The text on hover for the copy url button on the Customer portal settings page',
	},
	channelAccess: {
		id: 'servicedesk-settings-customer-portal-v2.portal-details.channel-access',
		defaultMessage: 'Channel access',
		description: 'Header on the service project settings page for Customer portal settings',
	},
	customization: {
		id: 'servicedesk-settings-customer-portal-v2.portal-details.customization',
		defaultMessage: 'Customization',
		description: 'Heading for portal customizations on customer portal page',
	},
	customizationLink: {
		id: 'servicedesk-settings-customer-portal-v2.portal-details.customization-link',
		defaultMessage: 'Customize portal',
		description: 'Link to portal customization on the customer portal settings page',
	},
});
